import { createElement } from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { CoverityIssueTypePicker } from '../CoverityPicker/coverityIssueType';
import { AAEmployeeInfo, AaEmployeeInformation } from './AAEmployeeInfo';
import {
  AIFoundrySelector,
  AIFoundrySelectorOutput,
  aiFoundrySelectorValidation,
} from '../../components/AIFoundrySelector';
import { AppCodeSearchPicker } from './appCodeSearch';
import { AppShortnamePicker } from './appShortname';
import { AppShortNamePickerSchema } from './appShortname.schema';
import { ClusterPicker } from './cluster';
import { ComponentInformation, componentInformationValidation } from './ComponentInformation/ComponentInformation';
import { DescriptionField, descriptionFieldValidation } from './description';
import { GithubRepoField, githubRepoFieldValidation } from './githubRepo';
import { GithubSecretsFieldPicker } from './GithubSecrets';
import { GithubTeamField, githubTeamFieldValidation } from './githubTeam';
import { GitHubUserId } from './githubUserInfo';
import { InfrastructureSelector } from './InfrastructureSelector/InfrastructureSelector';
import { LDAPGroupField } from './LDAPGroup';
import { MicrogatewayCheckbox } from './microgatewayCheckbox';
import { PaasAdminItemsField } from './paas/paasAdmin';
import { PaasFields } from './paas/paasForm';
import { PaasSpRgItemsField } from './paas/spRgElement';
import { SecretVaultForm, secretVaultFormFieldValidation } from './secretVault';
import { SecretVaultNamespaceForm } from './SecretVaultNamespace';
import { ServerNamingField } from './serverNaming';
import { SquadPicker, squadPickerValidation } from './squadPicker';
import { VerticalField } from './vertical';
import { MigrateAdoToGithubInformation } from './MigrateAdoToGithub/MigrateAdoToGithub';
import { AppShortnameAIValidator, appShortnameAIValidatorValidation } from './AppShortnameAIValidator';
import { ConductorTriggerTypeField, conductorTriggerTypeFieldValidation } from './ConductorInfo/ConductorTriggerForm';
import {
  AppShortnameAzureOnboardingValidator,
  appShortnameAzureOnboardingValidatorValidation,
} from './AppShortnameAzureOnboardingValidator';
import {
  AppShortnameOneTrustValidator,
  appShortnameOneTrustValidatorValidation,
} from './AppShortnameOneTrustValidator';
import {
  AppShortnameOneTrustAssessmentValidator,
  appShortnameOneTrustAssessmentValidatorValidation,
} from './AppShortnameOneTrustAssessmentValidator';

export const SquadPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SquadPickerFieldExtension',
    component: SquadPicker,
    validation: squadPickerValidation,
  }),
);

export const AppShortnamePickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppShortnamePickerFieldExtension',
    component: AppShortnamePicker,
    schema: AppShortNamePickerSchema.schema,
  }),
);

export const ClusterPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KubernetesClusterPickerFieldExtension',
    component: ClusterPicker,
    // cannot validate objects until https://github.com/backstage/backstage/issues/8542
  }),
);

export const GithubSecretsPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubSecretsPickerFieldExtension',
    component: GithubSecretsFieldPicker,
    // validation: GithubSecretsFieldPickerValidation,
  }),
);

export const GithubRepoFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubRepoFieldExtension',
    component: GithubRepoField,
    validation: githubRepoFieldValidation,
  }),
);

export const GithubTeamFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubTeamFieldExtension',
    component: GithubTeamField,
    validation: githubTeamFieldValidation,
  }),
);

export const DescriptionFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DescriptionFieldExtension',
    component: DescriptionField,
    validation: descriptionFieldValidation,
  }),
);

/**
 * @deprecated use `AAEmployeeInfoFieldExtension` instead.
 */
export const AaEmployeeInformationFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AaEmployeeInformationFieldExtension',
    component: AaEmployeeInformation,
  }),
);

export const AAEmployeeInfoFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AAEmployeeInfoFieldExtension',
    component: AAEmployeeInfo,
  }),
);

export const GitHubUserIdFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitHubUserIdFieldExtension',
    component: GitHubUserId,
  }),
);

export const VerticalFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'VerticalFieldExtension',
    component: VerticalField,
  }),
);

export const PaasAdminItemsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'PaasAdminItemsFieldExtension',
    component: PaasAdminItemsField,
  }),
);

export const PaasSpRgItemsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'PaasSpRgItemsFieldExtension',
    component: PaasSpRgItemsField,
  }),
);

export const PaasFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'PaasFieldExtension',
    component: PaasFields,
  }),
);

export const ServerNamingFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ServerNamingFieldExtension',
    component: ServerNamingField,
  }),
);

export const AppCodeSearchPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppCodeSearchPickerFieldExtension',
    component: AppCodeSearchPicker,
  }),
);

export const SecretVaultFormFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SecretVaultFormFieldExtension',
    component: SecretVaultForm,
    validation: secretVaultFormFieldValidation,
  }),
);

export const SecretVaultNamespaceFormFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SecretVaultNamespaceFormFieldExtension',
    component: SecretVaultNamespaceForm,
  }),
);

export const MicrogatewayPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'MicrogatewayPickerExtension',
    component: MicrogatewayCheckbox,
  }),
);

export const LDAPGroupFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'LDAPGroupFieldExtension',
    component: LDAPGroupField,
  }),
);

export const InfrastructureSelectorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'InfrastructureSelectorExtension',
    component: InfrastructureSelector,
  }),
);

export const ComponentInformationExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ComponentInformationExtension',
    component: ComponentInformation,
    validation: componentInformationValidation,
  }),
);

export const CoverityIssueTypeExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CoverityIssueTypeExtension',
    component: CoverityIssueTypePicker,
  }),
);

export const ConductorTriggerTypeFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ConductorTriggerTypeFieldExtension',
    component: ConductorTriggerTypeField,
    validation: conductorTriggerTypeFieldValidation,
  }),
);

export const MigrateAdoToGithubFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'MigrateAdoToGithubFieldExtension',
    component: MigrateAdoToGithubInformation,
  }),
);

export const AppShortnameAIValidatorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppShortnameAIValidatorExtension',
    component: AppShortnameAIValidator,
    validation: appShortnameAIValidatorValidation,
  }),
);

// Wrapper component to extract aiConfigData from formContext and pass to AIFoundrySelector
const AIFoundrySelectorFieldWrapper = ({
  onChange,
  formContext,
  ...props
}: FieldExtensionComponentProps<AIFoundrySelectorOutput>) => {
  // Extract data from the appShortnameValidation wrapper
  const validationResult = (formContext?.formData as any)?.appShortnameValidation;
  const aiConfigData = validationResult?.data || null;

  return createElement(AIFoundrySelector, {
    onChange,
    aiConfigData,
    ...props,
  });
};

export const AIFoundryFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AIFoundryFieldExtension',
    component: AIFoundrySelectorFieldWrapper,
    validation: aiFoundrySelectorValidation,
  }),
);

export const AppShortnameAzureOnboardingValidatorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppShortnameAzureOnboardingValidatorExtension',
    component: AppShortnameAzureOnboardingValidator,
    validation: appShortnameAzureOnboardingValidatorValidation,
  }),
);

export const AppShortnameOneTrustValidatorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppShortnameOneTrustValidatorExtension',
    component: AppShortnameOneTrustValidator,
    validation: appShortnameOneTrustValidatorValidation,
  }),
);

export const AppShortnameOneTrustAssessmentValidatorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppShortnameOneTrustAssessmentValidatorExtension',
    component: AppShortnameOneTrustAssessmentValidator,
    validation: appShortnameOneTrustAssessmentValidatorValidation,
  }),
);
